module.exports = __webpack_public_path__ + "static/cag5-3ce5b1ad78b329b4e503ade80152b2e2.png";